import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import {
  breakpoints,
  colors,
  fonts,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";
import { pageStyles } from "./one-pager-page.styles";

export function PlayOnePager({
  accent,
  hero,
  children,
  agentLinks,
}: {
  readonly accent: string;
  readonly hero: ReactNode;
  readonly children: ReactNode;
  readonly agentLinks: {
    readonly leaderboard: string | null;
    readonly rules: { readonly href: string; readonly label: string };
  };
}) {
  return (
    <div
      {...stylex.props(pageStyles.page, pageStyles.accent(accent))}
      data-testid="onepager"
    >
      {hero}
      {children}
      <footer {...stylex.props(styles.agents)}>
        For agents:{" "}
        {agentLinks.leaderboard ? (
          <>
            the same leaderboard as JSON at{" "}
            <a
              {...stylex.props(styles.agentLink)}
              href={agentLinks.leaderboard}
            >
              {agentLinks.leaderboard}
            </a>
            , and{" "}
          </>
        ) : null}
        how to play at{" "}
        <a {...stylex.props(styles.agentLink)} href={agentLinks.rules.href}>
          {agentLinks.rules.label}
        </a>
        .
      </footer>
    </div>
  );
}

const styles = stylex.create({
  agents: {
    margin: 0,
    fontSize: fontSizes.caption,
    color: colors.playMuted,
    order: { default: null, [breakpoints.playCompact]: 3 },
  },
  agentLink: {
    color: "inherit",
    fontFamily: fonts.mono,
    textDecoration: "none",
  },
});
